import React, { Component } from 'react'

import Search from './Search';
import Tests from './Tests';


class Index extends Component {
	render() {
		return (
			<div className="container main">
				<div className="row">
					<div className="col-md-6 col-lg-4">
						<Search
							onSearch={this.props.onSearch}
							professors={this.props.professors}
							professor={this.props.selectedProfessor}
							subject={this.props.selectedSubject}
						/>
					</div>
					<div className="col-md-6 col-lg-8">
						<Tests
							tests={this.props.tests}
							heading={this.props.heading}
							loadingState={this.props.loadingState}
						/>
					</div>
				</div>
			</div>
		)
	}

}

export default Index
